import { Component, Input } from '@angular/core';
import { AdminEditablePartComponent } from '../../admin-editable-part-component';

@Component({
  selector: 'thema-core-editable-expansion',
  templateUrl: './editable-expansion.component.html',
  styleUrls: ['./editable-expansion.component.scss'],
})
export class EditableExpansionComponent extends AdminEditablePartComponent {
  @Input()
  private initialContent: string[] = [
    'LOREM IPSUM',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    'LOREM IPSUM',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    'LOREM IPSUM',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  ];

  protected numberOfEditableElementsInSinglePartOfEachGroup = [2];
  public ngOnInit(): void {
    this.onPageCreateContent = [this.initialContent];
  }
}
